import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { FlashMessage } from '../components/FlashMessage';
import BrandLoader from '../components/BrandLoader';
import { error } from '../ErrorHandling';
import { errorAlert } from '../Notifications/Types';
import { sessionStore } from './Store';

function WhenApplicationSession({ children }: PropsWithChildren<{}>) {
  switch (sessionStore.state.kind) {
    case 'requesting':
      return <BrandLoader />;
    case 'present':
    case 'absent':
      return <>{children}</>;
    case 'errored':
      return (
        <div className="flex h-screen items-center justify-center">
          <FlashMessage
            alert={errorAlert(error('Unable to establish a session for this application.'))}
          />
        </div>
      );
  }
}

export default observer(WhenApplicationSession);
